import _ from 'lodash';
import io from 'socket.io-client';
import { log } from '@swiper/core';

const error = log.error.bind( log, '[socket.io]' );

const manager = io( {
  // path                    : '/socket.io',
  // reconnection            : true,
  // reconnectionAttempts    : Infinity,
  // reconnectionDelay       : 1000,
  // reconnectionDelayMax    : 5000,
  // randomizationFactor     : 0.5,
  // timeout                 : 20000,
  // autoConnect             : true,
  // query parameters to send when connecting a namespace
  // you can find them on the server-side in socket.handshake.query
  // query                   : {},
  // parser                  : <built-in>,
} );
export default manager;

manager.on( 'disconnect', reason => {
  if ( reason === 'io server disconnect' ) manager.connect();
} );
manager.on( 'error', err => error( 'Error:', err ) );
manager.on( 'connect_error', err => error( 'Connection Error:', err ) );
manager.on( 'connect_timeout', () => error( 'Connection timed out' ) );
manager.on( 'reconnect_error', err => error( 'Reconnect Error:', err ) );
manager.on( 'reconnect_failed', () => error( 'Reconnect Failed' ) );
